// 缺字段的显示名：字段名（中文意思）+ 单独的角色（谁的字段）。
// 旧问题把角色写在括号里（如「Occupation（担保人）」），这里拆开；没给中文意思的，常见门户字段按词表补上。
import type { MissingFieldRef } from "@csp/shared";

/** 括号里是这些词时当作角色，不是字段的中文意思 */
const ROLE_RE = /^(担保人|申请人|被担保人|配偶|父亲|母亲|子女|董事|股东|秘书|公司|雇主|本人|代理人|联系人|sponsor|applicant|director|shareholder|secretary|spouse)$/i;

/** 常见门户字段的中文意思（key 用小写、去掉标点和空格） */
const ZH: Record<string, string> = {
  occupation: "职业", jobtitle: "职位", designation: "职位", position: "职位",
  name: "姓名", fullname: "全名", nameasinpassport: "护照上的姓名", surname: "姓", givenname: "名",
  dateofbirth: "出生日期", dob: "出生日期", placeofbirth: "出生地", countryofbirth: "出生国家",
  sex: "性别", gender: "性别", nationality: "国籍", citizenship: "国籍", race: "种族", religion: "宗教",
  maritalstatus: "婚姻状况", relationship: "关系", relationshiptoapplicant: "与申请人的关系",
  passportno: "护照号码", passportnumber: "护照号码", traveldocumentno: "旅行证件号码", passportexpirydate: "护照到期日",
  nricfin: "身份证 / FIN 号码", nric: "身份证号码", fin: "FIN 号码", idno: "证件号码", identificationno: "证件号码",
  address: "地址", residentialaddress: "住址", postalcode: "邮编", country: "国家",
  email: "邮箱", emailaddress: "邮箱", contactnumber: "联系电话", mobilenumber: "手机号码", phonenumber: "电话号码",
  employer: "雇主", employername: "雇主名称", companyname: "公司名称", monthlysalary: "月薪", grossmonthlysalary: "月薪（税前）",
  annualincome: "年收入", highestqualification: "最高学历", education: "学历",
  purposeofvisit: "来访目的", reasonforappeal: "申诉理由", durationofstay: "停留时长",
};

export function fieldName(f: MissingFieldRef): { name: string; zh: string | null; role: string | null } {
  let name = f.label.trim();
  let role = f.role?.trim() || null;
  let zh = f.zh?.trim() || null;
  const m = name.match(/^(.*?)\s*[（(]([^（）()]+)[）)]\s*$/);
  if (m) {
    if (ROLE_RE.test(m[2]!.trim())) { role = role ?? m[2]!.trim(); name = m[1]!.trim(); }
    else if (!/[a-z]/i.test(m[2]!) && /[a-z]/i.test(m[1]!)) { zh = zh ?? m[2]!.trim(); name = m[1]!.trim(); }
  }
  // 旧提问 zh 写成「担保人的职业」这类：去掉角色前缀
  if (zh && role && zh.startsWith(`${role}的`)) zh = zh.slice(role.length + 1);
  zh = zh ?? ZH[name.toLowerCase().replace(/[^a-z]/g, "")] ?? null;
  if (zh === name) zh = null;
  return { name, zh, role };
}
